'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _HowItWorks = require('./HowItWorks.css');

var _HowItWorks2 = _interopRequireDefault(_HowItWorks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HowItWorks = (_dec = (0, _reactCssModules2.default)(_HowItWorks2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HowItWorks, _Component);

  function HowItWorks(props) {
    (0, _classCallCheck3.default)(this, HowItWorks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HowItWorks.__proto__ || (0, _getPrototypeOf2.default)(HowItWorks)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(HowItWorks, [{
    key: 'render',
    value: function render() {
      var title = 'How it works';
      var link = _config2.default.domain + _config2.default.routes.works;
      // const message = config.shareMessage

      // IMAGES
      var sriIcon = require('../../../static/images/sri.png');
      var ussifIcon = require('../../../static/images/ussif-logo.png');
      var listTobaccoHoldings = require('../../../static/images/list-tobacco-holdings.png');
      var tobaccoPieChart = require('../../../static/images/tobacco-pie-chart.png');

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(title),
        _react2.default.createElement(
          'div',
          { styleName: 'title-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'title-wrap-inner' },
            _react2.default.createElement(
              'h1',
              { styleName: 'page-title' },
              title
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lede' },
              'Tobacco Free Funds sources financial data from Morningstar, an investment research company. We use Morningstar\u2019s mutual fund and stock data to analyze funds and find investments in tobacco and tobacco-promoting entertainment companies. Our database Covers thousands of the most popular mutual funds, the type of investments most common in retirement plans like employer-offered 401(k)s.'
            ),
            _react2.default.createElement(_components.Changelog, null)
          )
        ),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(
          'div',
          { styleName: 'how-it-works' },
          _react2.default.createElement(
            'div',
            { styleName: 'how-it-works-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Finding a fund'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Tobacco Free Funds'
                ),
                ' sources financial data on equities and mutual funds from Morningstar. Our database contains information on thousands of U.S. open-end and exchange traded mutual funds, some of the most common funds held in 401(k)s, 403(b)s, and other retirement plans.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Search for mutual funds using name or ticker symbol. Use the search page to filter funds by investing style, fund family, regional market, and more. We don\'t have everything in our database - we only screen mutual funds that own stocks, and can only display up to 3,000. Looking for your favorite fund and can\u2019t find it? With more resources, we could include more funds - ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    xstrong: true,
                    to: _config2.default.links.donate,
                    title: 'Donate to As You Sow'
                  },
                  'make a gift today to make a difference.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Screening a fund'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'For each mutual fund in our database, we examine every holding and determine if it is a stock issued by a tobacco company or a tobacco-promoting entertainment company.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Holdings that are not stocks, like currencies, bonds, or other mutual funds, are not rated. A fund\u2019s Percent Rated value is equivalent to the percent of the fund that is invested in stocks. The higher a fund\u2019s Percent Rated value, the more holdings we were able to examine. A fund with a lower Percent Rated value may have hidden tobacco-related investments that our tool cannot account for.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'If a fund holds stock in a flagged company'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Two screens are applied to each fund \u2013 a list of tobacco companies, and a list of entertainment companies that promote tobacco to young audiences.'
              ),
              _react2.default.createElement(_components.ScreenedCompanies, null)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'We calculate the total amount of exposure'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. We calculate the total number of flagged holdings in the fund, and the total amount and percentage of the fund\u2019s assets that are invested in those companies.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'sidebar' },
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar-title' },
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
                '\xA0',
                _react2.default.createElement(
                  'em',
                  null,
                  'Measuring long holdings only'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'When calculating a fund\'s exposure to a screen list, we only consider the portfolio\'s long investments, ignoring any shorts or liabilities. The formula for holding weight is ',
                  _react2.default.createElement(
                    'em',
                    null,
                    'holding market value divided by the sum of the market value for all long holdings in the portfolio.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in tobacco producers or tobacco-promoting entertainment studios, you\'ll see a chart like this showing the details:'
              ),
              _react2.default.createElement('img', {
                src: tobaccoPieChart,
                alt: 'If a fund has investments in tobacco, you\'ll see a chart like this'
              }),
              _react2.default.createElement(
                'p',
                null,
                'You\'ll also see a list of all the specific tobacco investments of that fund\'s portfolio.'
              ),
              _react2.default.createElement('img', {
                src: listTobaccoHoldings,
                alt: 'If a fund has investments in tobacco, you\'ll see a list like this'
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'We assign a Tobacco Grade'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Based on whether or not a fund has investment in tobacco companies and/or tobacco-promoting entertainment companies, we assign a letter grade.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullet' },
                _react2.default.createElement(_components.Grade, { grade: 1, large: true }),
                _react2.default.createElement(
                  'p',
                  { styleName: 'screen-icon-label' },
                  'No holdings flagged for our tobacco screens. Assigned a grade of A.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullet' },
                _react2.default.createElement(_components.Grade, { grade: 2, large: true }),
                _react2.default.createElement(
                  'p',
                  { styleName: 'screen-icon-label' },
                  'Fund is invested in tobacco-promoting entertainment companies, but no holdings flagged for our tobacco producer screen. Assigned a grade of B.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullet' },
                _react2.default.createElement(_components.Grade, { grade: 3, large: true }),
                _react2.default.createElement(
                  'p',
                  { styleName: 'screen-icon-label' },
                  'Fund is invested in tobacco producers, below the threshold of 0.5%. Assigned a grade of C.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullet' },
                _react2.default.createElement(_components.Grade, { grade: 4, large: true }),
                _react2.default.createElement(
                  'p',
                  { styleName: 'screen-icon-label' },
                  'Fund is invested in tobacco producers, above the threshold of 0.5% and below 1.2%. Assigned a grade of D.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullet' },
                _react2.default.createElement(_components.Grade, { grade: 5, large: true }),
                _react2.default.createElement(
                  'p',
                  { styleName: 'screen-icon-label' },
                  'Fund is invested in tobacco producers, above the threshold of 1.2%. Assigned a grade of F.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'These thresholds reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in the C, D, and F grade ranges.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund owns some of the companies we screen for, but has a proven track record of engaging the companies it owns by taking actions such as ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://go.asyousow.org/take-action-tobacco-free-funds', title: 'Read the investor letter signed by firms managing over $64 billion in assets' },
                  'signing our Investor Statement on Tobacco Depictions in Movies,'
                ),
                ' it earns a special acknowledgement as a \u201Cknown sustainability engager\u201D, instead of a letter grade.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullet' },
                _react2.default.createElement(_components.Grade, { grade: 1.5, large: true }),
                _react2.default.createElement(
                  'p',
                  { styleName: 'screen-icon-label' },
                  '\u201CKnown sustainability engager\u201D grade. Fund is offered by an asset manager that frequently engages companies it invests in to push for better behavior using the shareholder resolution process.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.routes.faq + '#5', title: 'More about how fund managers engage companies on tobacco in youth entertainment' },
                  ' Read more about how fund managers engage companies on tobacco in youth entertainment.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'We track sustainable funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'We use Morningstar\'s "sustainability mandate" indicator to determine which funds are displayed as socially responsible. Funds with sustainability mandates often make investment decisions based on issues like environmental responsibility, human rights, or religious views. A socially responsible fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are designated socially responsible.'
              ),
              _react2.default.createElement('img', {
                styleName: 'sri',
                src: sriIcon,
                alt: 'Socially responsible fund',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-html': true,
                'data-for': 'sri-icons-tooltip',
                'data-place': 'bottom',
                'data-tip': _format2.default.tooltipHtml('Designated a sustainably mandated/socially responsible ' + 'fund by Morningstar. Socially responsible funds ' + 'consider issues like the environment and human rights.')
              }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'sri-icons-tooltip' }),
              _react2.default.createElement(
                'p',
                null,
                'The Forum for Sustainable and Responsible Investment is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of civilian firearms. Look for this symbol to find funds that are members of US-SIF.'
              ),
              _react2.default.createElement('img', {
                styleName: 'ussif',
                src: ussifIcon,
                alt: 'Member of US-SIF, the Forum for Sustainable and ' + 'Responsible Investment',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-html': true,
                'data-for': 'ussif-icons-tooltip',
                'data-place': 'bottom',
                'data-tip': _format2.default.tooltipHtml('Member of US-SIF, the Forum for Sustainable and ' + 'Responsible Investment')
              }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'ussif-icons-tooltip' })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-title' },
              'Tobacco free action toolkit'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'When you\'re done looking up funds and finding the data you need, what\'s next? You can learn how to make a change and move your money with our ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    xstrong: true,
                    to: _config2.default.routes.toolkit,
                    title: 'Action toolkit | Tobacco Free Funds'
                  },
                  'tobacco free action toolkit'
                ),
                '. Whether you\u2019re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There\'s an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more \u2014 everything you need to make a change and get started investing your money tobacco free.'
              )
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(_components.DonateBanner, null),
        _react2.default.createElement(
          'div',
          { styleName: 'banner-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return HowItWorks;
}(_react.Component)) || _class);
exports.default = HowItWorks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/HowItWorks/HowItWorks.js
// module id = 1293
// module chunks = 0